import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as ReportsService from "../../services/ReportsService";
import { HttpCodes } from "constants/app.constant";
// import { HttpCodes } from "../constants/app.constant"; // Commented out due to missing module

export interface State {
  countryList: any[];
  isCountryLoading: boolean;
  appConfigs: any[];
  isAppConfigsLoading: boolean;
  filtersList: any[];
  isFiltersLoading: boolean;
  globalFilters: any;
  reportsData: any;
  isReportsLoading: boolean;
}

const initialState: State = {
  countryList: [],
  isCountryLoading: false,
  appConfigs: [],
  isAppConfigsLoading: false,
  filtersList: [],
  isFiltersLoading: false,
  globalFilters: null,
  reportsData: {},
  isReportsLoading: false
};

export const countryListThunk = createAsyncThunk(
  "reports/countryListThunk",
  async (payload: any, thunkApi) => {
    try {
      const response = await ReportsService.getCountryList(payload);
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const appConfigThunk = createAsyncThunk(
  "reports/appConfigThunk",
  async (payload: any, thunkApi) => {
    try {
      const response = await ReportsService.getAppConfig(payload);
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const reportFiltersThunk = createAsyncThunk(
  "reports/reportFiltersThunk",
  async (payload: any, thunkApi) => {
    try {
      const response = await ReportsService.getReportFilters(payload);
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const reportDataThunk = createAsyncThunk(
  "reports/reportDataThunk",
  async (payload: any, thunkApi) => {
    try {
      const response = await ReportsService.getReportData(
        payload.type,
        payload.filters
      );
      if (response.responseCode == HttpCodes.SUCCESS) {
        return { type: payload.type, data: response.data || {} };
      }
      return [];
    } catch (e) {
      console.log(e);
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    resetState: () => initialState,
    setGlobalFilters: (state, action) => {
      state.globalFilters = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(countryListThunk.pending, (state, action) => {
      state.isCountryLoading = true;
    });
    builder.addCase(countryListThunk.fulfilled, (state, action) => {
      state.isCountryLoading = false;
      state.countryList = action.payload;
    });
    builder.addCase(countryListThunk.rejected, (state, action) => {
      state.isCountryLoading = false;
      state.countryList = [];
    });

    builder.addCase(appConfigThunk.pending, (state, action) => {
      state.isAppConfigsLoading = true;
    });
    builder.addCase(appConfigThunk.fulfilled, (state, action) => {
      state.isAppConfigsLoading = false;
      state.appConfigs = action.payload;
    });
    builder.addCase(appConfigThunk.rejected, (state, action) => {
      state.isAppConfigsLoading = false;
      state.appConfigs = [];
    });

    builder.addCase(reportFiltersThunk.pending, (state, action) => {
      state.isFiltersLoading = true;
    });
    builder.addCase(reportFiltersThunk.fulfilled, (state, action) => {
      state.isFiltersLoading = false;
      state.filtersList = action.payload;
    });
    builder.addCase(reportFiltersThunk.rejected, (state, action) => {
      state.isFiltersLoading = false;
      state.filtersList = [];
    });

    builder.addCase(reportDataThunk.pending, (state, action) => {
      state.isReportsLoading = true;
    });
    builder.addCase(reportDataThunk.fulfilled, (state, action: any) => {
      state.isReportsLoading = false;
      state.reportsData[action.payload.type] = action.payload.data;
    });
    builder.addCase(reportDataThunk.rejected, (state, action: any) => {
      state.isReportsLoading = false;
      state.reportsData[action.payload.type] = [];
    });
  }
});

export const { setGlobalFilters, resetState } = reportsSlice.actions;

export default reportsSlice.reducer;
